import type { PracticeMode, SupportLevel } from "./types.ts";

export function practiceDisclosure(mode: PracticeMode, feedback = false) {
  return {
    namesAnswer: mode === "learn" || feedback,
    futureMoves: mode === "learn",
    coursePieceGuides: mode === "learn",
    branchBriefing: mode === "branches" || mode === "learn" || feedback,
    revealComparisons: mode === "learn" || feedback,
  };
}

/** Do not infer disclosure from a hint's position in the ladder. */
export function hintSupport(id: string, revealsAnswer = false): SupportLevel {
  if (revealsAnswer || id === "move" || id === "explanation") return "answer";
  if (id === "candidates") return "candidates";
  if (id === "piece") return "piece";
  return "goal";
}
